"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = rootSaga;

var _effects = require("redux-saga/effects");

var _fetchAuthentication = require("./fetchAuthentication");

var _fetchAuthentication2 = _interopRequireDefault(_fetchAuthentication);

var _fetchBookingMetaData = require("./fetchBookingMetaData");

var _fetchBookingMetaData2 = _interopRequireDefault(_fetchBookingMetaData);

var _fetchCheckinData = require("./fetchCheckinData");

var _fetchCheckinData2 = _interopRequireDefault(_fetchCheckinData);

var _fetchBookingData = require("./fetchBookingData");

var _fetchBookingData2 = _interopRequireDefault(_fetchBookingData);

var _fetchLinkedBookingsCustomerData = require("./fetchLinkedBookingsCustomerData");

var _fetchLinkedBookingsCustomerData2 = _interopRequireDefault(_fetchLinkedBookingsCustomerData);

var _fetchCustomersData = require("./fetchCustomersData");

var _fetchCustomersData2 = _interopRequireDefault(_fetchCustomersData);

var _fetchDepartureServicesData = require("./fetchDepartureServicesData");

var _fetchDepartureServicesData2 = _interopRequireDefault(_fetchDepartureServicesData);

var _fetchRoomingListsData = require("./fetchRoomingListsData");

var _fetchRoomingListsData2 = _interopRequireDefault(_fetchRoomingListsData);

var _fetchProfilesData = require("./fetchProfilesData");

var _fetchProfilesData2 = _interopRequireDefault(_fetchProfilesData);

var _fetchRequirementData = require("./fetchRequirementData");

var _fetchRequirementData2 = _interopRequireDefault(_fetchRequirementData);

var _listenForReduxFormSubmit = require("./listenForReduxFormSubmit");

var _listenForReduxFormSubmit2 = _interopRequireDefault(_listenForReduxFormSubmit);

var _sendReminderMessage = require("./sendReminderMessage");

var _sendReminderMessage2 = _interopRequireDefault(_sendReminderMessage);

var _triggerBookingSubresourceRequests = require("./triggerBookingSubresourceRequests");

var _triggerBookingSubresourceRequests2 = _interopRequireDefault(_triggerBookingSubresourceRequests);

var _updateResources = require("./updateResources");

var _updateResources2 = _interopRequireDefault(_updateResources);

var _fetchPrimaryCustomerData = require("./fetchPrimaryCustomerData");

var _fetchPrimaryCustomerData2 = _interopRequireDefault(_fetchPrimaryCustomerData);

var _fetchTransferServicesData = require("./fetchTransferServicesData");

var _fetchTransferServicesData2 = _interopRequireDefault(_fetchTransferServicesData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga); // Exports the root saga

// Each saga listens for an action and responds with an effect
//  (dispatching another action, calling the API, etc.)
function rootSaga() {
    return _regenerator2.default.wrap(function rootSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.fork)(_fetchAuthentication2.default);

                case 2:
                    _context.next = 4;
                    return (0, _effects.fork)(_fetchBookingMetaData2.default);

                case 4:
                    _context.next = 6;
                    return (0, _effects.fork)(_fetchBookingData2.default);

                case 6:
                    _context.next = 8;
                    return (0, _effects.fork)(_fetchPrimaryCustomerData2.default);

                case 8:
                    _context.next = 10;
                    return (0, _effects.fork)(_fetchCheckinData2.default);

                case 10:
                    _context.next = 12;
                    return (0, _effects.fork)(_fetchRoomingListsData2.default);

                case 12:
                    _context.next = 14;
                    return (0, _effects.fork)(_fetchTransferServicesData2.default);

                case 14:
                    _context.next = 16;
                    return (0, _effects.fork)(_fetchLinkedBookingsCustomerData2.default);

                case 16:
                    _context.next = 18;
                    return (0, _effects.fork)(_fetchCustomersData2.default);

                case 18:
                    _context.next = 20;
                    return (0, _effects.fork)(_fetchDepartureServicesData2.default);

                case 20:
                    _context.next = 22;
                    return (0, _effects.fork)(_fetchProfilesData2.default);

                case 22:
                    _context.next = 24;
                    return (0, _effects.fork)(_fetchRequirementData2.default);

                case 24:
                    _context.next = 26;
                    return (0, _effects.fork)(_listenForReduxFormSubmit2.default);

                case 26:
                    _context.next = 28;
                    return (0, _effects.fork)(_sendReminderMessage2.default);

                case 28:
                    _context.next = 30;
                    return (0, _effects.fork)(_triggerBookingSubresourceRequests2.default);

                case 30:
                    _context.next = 32;
                    return (0, _effects.fork)(_updateResources2.default);

                case 32:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/index.js
// module id = 1419
// module chunks = 0